import { Button } from '@/shared/ui';
import { Download, Loader2 } from 'lucide-react';

/**
 * Contorno mais leve que o do design system: borda de 1px e anel só no foco
 * pelo teclado, em vez da borda de 2px com anel escuro de 4px a cada clique.
 * O `!` é preciso para vencer as classes do pacote, como em outras telas.
 */
const DOWNLOAD_BUTTON_CLASSES =
  'flex items-center gap-2 border! border-alba-gray-300! hover:border-alba-blue-500! focus:ring-0! focus-visible:ring-2! focus-visible:ring-alba-blue-500/40!';

type PaymentReceiptDownloadProps = {
  onDownload: () => void;
  downloading: boolean;
  /** Mensagem da última tentativa que falhou. */
  error?: string;
};

/** Botão do comprovante em PDF, com o erro logo abaixo quando o download falha. */
export function PaymentReceiptDownload({
  onDownload,
  downloading,
  error,
}: PaymentReceiptDownloadProps) {
  const Icon = downloading ? Loader2 : Download;

  return (
    <div className='flex flex-col items-center gap-2'>
      <Button
        type='button'
        variant='outline'
        size='md'
        className={DOWNLOAD_BUTTON_CLASSES}
        onClick={onDownload}
        disabled={downloading}
      >
        <Icon
          aria-hidden='true'
          className={`h-5 w-5 ${downloading ? 'animate-spin' : ''}`}
          strokeWidth={1.6}
        />
        {downloading ? 'Gerando o PDF…' : 'Baixar comprovante em PDF'}
      </Button>
      {error && (
        <p role='alert' className='text-center text-xs text-alba-error-red-600'>
          {error}
        </p>
      )}
    </div>
  );
}
